import { render, staticRenderFns } from "./Membertype.vue?vue&type=template&id=0235db34"
import script from "./Membertype.vue?vue&type=script&lang=js"
export * from "./Membertype.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports